import React from 'react';

const DialogViewReply = ({ open, onClose, email }) => {
    if (!open || !email) return null;

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = timestamp.seconds ? new Date(timestamp.seconds * 1000) : new Date(timestamp);
        return date.toLocaleString();
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-[#1D1D1D] p-6 rounded-lg w-full max-w-2xl">
                <h2 className="text-white text-lg font-bold mb-4">View Replied Message</h2>
                <div className="text-gray-300 text-sm space-y-3 mb-4">
                    <div><strong>From:</strong> {email.from_name} ({email.reply_to})</div>
                    <div><strong>Replied At:</strong> {formatDate(email.replied_at)}</div>
                    <div><strong>Replied By:</strong> {email.replier ? email.replier.displayName || email.replier.email || 'Unknown' : 'Unknown'}</div>
                    <div><strong>Reply Content:</strong></div>
                    <div className="bg-[#2E2E2E] p-3 rounded text-white whitespace-pre-wrap">
                        {email.reply_content || 'No reply content available'}
                    </div>
                </div>
                <button
                    className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-600"
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default DialogViewReply;